var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow_right_alt",
  "use": "arrow_right_alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_right_alt\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M16.01 11H4v2h12.01v3L20 12l-3.99-4z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol